var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      attrs: {
        expand: false,
        title: _vm.$t("settings.regionConfig.moduleTitle.itq_tender"),
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "tnc-collapse__content",
          attrs: { slot: "content" },
          slot: "content",
        },
        _vm._l(_vm.parsedI18nData, function (item, index) {
          return _c(
            "a-row",
            { key: index, attrs: { gutter: [10, 30] } },
            [
              _c("a-col", { attrs: { span: 7 } }, [
                _c("label", [_vm._v(_vm._s(item.label))]),
              ]),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 17 } },
                [
                  _vm.isEditing
                    ? _c("HKLTextareaVue", {
                        staticClass: "textarea__box",
                        attrs: { value: item["" + _vm.currentLanguage] },
                        on: {
                          onChange: function (val) {
                            return _vm.onChangeVal(
                              val,
                              index,
                              _vm.currentLanguage
                            )
                          },
                        },
                      })
                    : _c("div", { staticClass: "tnc__item-value" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(item["" + _vm.currentLanguage]) +
                            "\n        "
                        ),
                      ]),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }